import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["audio", "playIcon", "pauseIcon"]

  connect() {
    this._pause = () => this.audioTarget.pause()
    this.element.closest("[data-floating-menu-target='menu']")
      ?.addEventListener("floating-menu:hide", this._pause)
  }

  disconnect() {
    this.element.closest("[data-floating-menu-target='menu']")
      ?.removeEventListener("floating-menu:hide", this._pause)
  }

  toggle() {
    const audio = this.audioTarget
    if (audio.paused) {
      document.querySelectorAll("audio").forEach(a => { if (a !== audio) a.pause() })
      audio.play()
    } else {
      audio.pause()
    }
  }

  playing() {
    this.playIconTarget.classList.add("hidden")
    this.pauseIconTarget.classList.remove("hidden")
  }

  paused() {
    this.playIconTarget.classList.remove("hidden")
    this.pauseIconTarget.classList.add("hidden")
  }
}
